<template>
  <div class="app-container bg-f3f4f7" style="padding: 10px 20px 20px">
    <div class="flex content-top mb-10">
      <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
        <div class="tab-item active">
          <span class="bg-4-f5971d"></span>
          仓库列表
        </div>
      </div>
    </div>
    <div class="mb-10 flex">
      <div class="btn-24-bg-ff flex align-center mr-5" @click="onAdd">
        <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
        新增仓库
      </div>
      <div class="btn-24-bg-ff flex align-center" @click="onDelete" v-if="permission.includes('warehouseDelete')">
        <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
        删除仓库
      </div>
    </div>
    <div class="flex-1">
      <div class="h-100 flex-column">
        <div class="flex-1 mb-10">
          <div class="h-100">
            <erp-table :table-data="tableData" :column-data="columnData" ref="erpTable" @on-modify="onModify" modify-method="on-modify" :is-edit="true"></erp-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="添加仓库" :visible.sync="warehouseVisible" width="30%">
      <div class="flex align-center mb-10 p-20">
        <div class="font-12-30313a mr-5">名称：</div>
        <el-input v-model="storehouseValue" placeholder="请输入仓库" class="flex-1"></el-input>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="closeSelect">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitSelect">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ErpTable from '../../components/ErpTable'
import Pagination from '../../components/Pagination'

export default {
  name: 'warehouseDefine',
  components: {ErpTable, Pagination},
  data () {
    return {
      warehouseVisible: false,
      storehouseValue: null,
      tableData: [],
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        }, {
          field: 'name',
          title: '仓库名称',
          width: '350',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'remark',
          title: '备注',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      permission: []
    }
  },
  created () {
    this.getData()
    this.getPermission()
  },
  mounted () {},
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'warehouseDefine',
        parentGroup: 'warehouseDefine'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    onDelete () {
      let priceArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < priceArr.length; i++) {
        idArr.push(priceArr[i].id)
        nameArr.push(priceArr[i].name)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('storehouse/deleteByIds', that.qs.stringify({ids: idArr.join(',')})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            that.$refs.erpTable.setAllSelection(false)
            that.getData()
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onAdd () {
      this.warehouseVisible = true
    },
    closeSelect () {
      this.warehouseVisible = false
      this.storehouseValue = null
    },
    submitSelect () {
      if (!this.storehouseValue.replace(/^\s*|\s*$/g, '')) {
        this.$message({
          message: '填写仓库名称',
          type: 'warning'
        })
      } else {
        let params = {
          companyId: this.$store.state.companyId,
          name: this.storehouseValue
        }
        this.axios.post('storehouse/save', params).then(res => {
          if (res.data.success) {
            this.getData()
            this.closeSelect()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onModify (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('storehouse/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getData () {
      this.axios.post('storehouse/list', {companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/warehouseDefine.vue